import { ExtractVariables, apollo } from './graphql';
import { Membership } from './membership';
import { ACCEPT_INVITE, ACCEPT_SIGNUP_INVITE, GET_INVITE, SEND_INVITE } from './queries/invite';

export async function sendInvite(variables: ExtractVariables<typeof SEND_INVITE>): Promise<void> {
  await apollo.mutate({
    mutation: SEND_INVITE,
    variables,
  });
}

export async function getInvite(token: string): Promise<Membership> {
  const response = await apollo.query<{ invite: Membership }>({
    query: GET_INVITE,
    variables: {
      token,
    },
  });

  return response.data.invite;
}

export async function acceptSignupInvite(
  variables: ExtractVariables<typeof ACCEPT_SIGNUP_INVITE>
): Promise<Partial<Membership> | null> {
  const response = await apollo.mutate({
    mutation: ACCEPT_SIGNUP_INVITE,
    variables,
  });

  return response.data?.acceptSignupInvite?.membership || null;
}

export async function acceptInvite(inviteToken?: string): Promise<Partial<Membership> | null> {
  const response = await apollo.mutate({
    mutation: ACCEPT_INVITE,
    variables: {
      inviteToken,
    },
  });

  return response.data?.acceptInvite?.membership || null;
}
